import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ExpandedSecondary.module.scss"
import ExpandedSecondaryContent from "./ExpandedSecondaryContent"

type Props = {
	show: boolean
	element: AdvancedSideAssetMainContent
	withAspectRation?: boolean
}

const ExpandedSecondaryAnimation = (props: Props) => {
	return (
		<div
			className={`${
				props.show ? styles.listEnterActive : styles.listExitActive
			}`}
		>
			<ExpandedSecondaryContent
				data={props.element}
				withAspectRation={props.withAspectRation}
			/>
		</div>
	)
}

export default ExpandedSecondaryAnimation
